export const ConversationCardConstants = {
   USAGE: 'usage',
   NO_OF_DEVICES: 'noOfDevices',
};
